module.exports = __webpack_public_path__ + "static/img/11.3f10003.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/sp/11.png
// module id = 5SKQ
// module chunks = 0